import type React from "react";

import { IconButton } from "@/components/Button/IconButton";
import { DynamicRepeaterItem } from "@/components/DynamicRepeater/DynamicRepeaterItem";
import { ArrowDownIcon } from "@/components/Icons/ArrowDownIcon";
import { ArrowUpIcon } from "@/components/Icons/ArrowUpIcon";
import { Inline } from "@/design-system/Inline";

interface SurveyRespondQuestionCardDynamicRepeaterItemProps {
  id: string;
  title: string;
  description?: string;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMove: (direction: "up" | "down") => void;
  disabled?: boolean;
}

export function SurveyRespondQuestionCardDynamicRepeaterItem({
  id,
  title,
  description,
  canMoveUp,
  canMoveDown,
  onMove,
  disabled,
}: SurveyRespondQuestionCardDynamicRepeaterItemProps): React.ReactNode {
  return (
    <DynamicRepeaterItem
      id={id}
      title={title}
      disabled={disabled}
      headerActions={
        (canMoveDown || canMoveUp) && (
          <Inline gap="xs" align="center">
            <IconButton
              title="Move up"
              variant="soft"
              icon={<ArrowUpIcon />}
              disabled={!canMoveUp}
              size="sm"
              onClick={() => onMove("up")}
              isCircular
            />
            <IconButton
              title="Move down"
              variant="soft"
              icon={<ArrowDownIcon />}
              disabled={!canMoveDown}
              size="sm"
              onClick={() => onMove("down")}
              isCircular
            />
          </Inline>
        )
      }
    >
      {description && <p className="text-body text-text-secondary">{description}</p>}
    </DynamicRepeaterItem>
  );
}
